<template>
    
</template>

<script>

    export default {
        name: 'depot-detail',
    }
</script>
